module.exports = __webpack_public_path__ + "static/media/instagram.8ab86d87.png";